import React from 'react';
import { Download } from '@mui/icons-material';

export const DownloadEquipmentOptions = {
  DOWNLOAD_ALL_EQUIPMENTS: 'DOWNLOAD_ALL_EQUIPMENTS',
  DOWNLOAD_EQUIPMENTS_BY_STATE: 'DOWNLOAD_EQUIPMENTS_BY_STATE'
};

export const downloadEquipmentMenuOptions = [
  {
    label: 'COMMON.DOWNLOAD_ACTIVE_EQUIPMENTS',
    key: DownloadEquipmentOptions.DOWNLOAD_ALL_EQUIPMENTS,
    icon: <Download />
  },
  {
    label: 'COMMON.DOWNLOAD_EQUIPMENTS_BY_STATE',
    key: DownloadEquipmentOptions.DOWNLOAD_EQUIPMENTS_BY_STATE,
    icon: <Download />
  }
];
